import axios from 'axios';

import { AUTH_USER } from './userActionTypes';
import { getCookie } from 'lib/cookies';

export function auth() {
  const config = {
    headers: {
      'Authorization': `Bearer ${getCookie('access')}`,
    },
  };

  const request = axios
    .get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_USER_API}/auth`, config)
    .then(response => response.data);

  return {
    type: AUTH_USER,
    payload: request
  };
}
